<template>
  <div id="app">
    <!-- Spinner Loading (Border Spinner Minible) -->
    <div v-if="isLoading" class="spinner-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- Konten utama -->
    <router-view />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  data() {
    return {
      isLoading: false, // State loading
    };
  },
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
  watch: {
    /**
     * Bersihkan notifikasi saat route berubah
     */
    $route() {
      this.clearNotification();
    },
  },
  mounted() {
    // Tambahkan listener ke Vue Router untuk menampilkan spinner saat pindah halaman
    this.$router.beforeEach((to, from, next) => {
      this.isLoading = true;
      next();
    });

    this.$router.afterEach(() => {
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // Tambahkan delay agar terlihat
    });
  },
};
</script>

<style>
/* Overlay untuk spinner */
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
</style>
